import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../components/Loading';
import RewardList from './RewardList';
import NotFound from '../not-found/NotFound';
import GenericHelmet from '../generic-helmet/GenericHelmet';
import { getSharingTextForProject } from '../project-model';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import Main from '../../frame/main/Main';
import { getProjectFromId, getPublishedRewardsForProject } from '../projects-reducer';
import ProjectContext from '../project-context';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import { FloatingTotal } from '../payment/cart/FloatingTotal';
import { useParams } from 'react-router';
import { fetchCart } from '../../cart/cart-actions';
import ProjectSupportButtons from '../project-show/project-support-buttons/ProjectSupportButtons';
import styles from './choose-reward.module.less';
import ProjectPolls from '../project-show/project-polls/ProjectPolls';
import { fetchProjectCard, fetchRewards, fetchRewardsPurchasedCount } from '../project-actions';

const ChooseReward = () => {
    const params = useParams();
    const project = useSelector((state) => getProjectFromId(state, params?.projectId));
    const isFetchingCards = useSelector((state) => state.projects.isFetchingCards) && !project?.created_at;
    const rewards = useSelector((state) => getPublishedRewardsForProject(state, project.id));
    const dispatch = useDispatch();

    useEffect(() => {
        if (project?.id) {
            trackPageView({ urlAsEvent: 'project-rewards', properties: { 'project-id': project?.id } });
        }
    }, [project?.id]);

    useEffect(() => {
        if (project?.id) {
            dispatch(fetchCart({ projectId: project?.id }));
        }
    }, [project?.id]);

    if (isFetchingCards) {
        return (
            <Main>
                <Loading />
            </Main>
        );
    }

    if (!project || !rewards) {
        return (
            <Main>
                <NotFound />
            </Main>
        );
    }

    return (
        <Main>
            <ProjectContext.Provider value={project}>
                <GenericHelmet title={project.title} description={getSharingTextForProject(project)}>
                    <div className={styles.container}>
                        <div className={styles.mainContent}>
                            <ProjectPolls includeStoppedPolls={false} />
                            <RewardList rewards={rewards} className={styles.rewards} onProjectPage={false} />
                            <TrackEventLink
                                to={`/project/${project.id}`}
                                category="reward-page"
                                action="support-project-from-rewards-cancel"
                                properties={{ 'project-id': project.id }}
                            >
                                Avbryt
                            </TrackEventLink>
                            <FloatingTotal />
                        </div>
                    </div>
                    <ProjectSupportButtons className={styles.supportButtons} />
                </GenericHelmet>
            </ProjectContext.Provider>
        </Main>
    );
};

export const loader = async ({ dispatch, params }) => {
    await Promise.all([
        dispatch(fetchProjectCard(params.projectId)),
        dispatch(fetchRewards(params.projectId)),
        dispatch(fetchRewardsPurchasedCount(params.projectId)),
    ]);
};

export default ChooseReward;
